/* tslint:disable */
export const ru_overrides_strings = {
};
